export default "__VITE_ASSET__DUl5m3sq__"